export default __webpack_public_path__ + "static/media/DashbaordMeasure.893f391c.svg";